module.exports = __webpack_public_path__ + "img/ico-14-active.df50c9dc.svg";